<template>
    <div class="gift_record_container">
        <!-- <global-tag> -->
        <div class="elder_manage_title">
            <p class="title">组织工作</p>
        </div>
        <div class="headerMain">
            <div class="newIndexContainer">
                <div class="organizedLeft">
                    <el-select
                        @change="onSelectOrgIdChange"
                        v-model="socialOrgId"
                        class="organizeSelct"
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="item in orgList"
                            :key="item.id"
                            :label="item.communityName"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                    <div class="yzListDiv">
                        <div
                            class="yzListDivLeft yzListDivLeftBlue"
                            @click="cardMessage('base')"
                        >
                            <img src="@/assets/images/personalIcon.png" alt />
                            <div>
                                <p>组织基本信息</p>
                            </div>
                        </div>
                    </div>
                    <div class="yzListDiv">
                        <div
                            class="yzListDivLeft yzListDivLeftViolet"
                            @click="cardMessage('member')"
                        >
                            <img src="@/assets/images/enterpriseIcon.png" alt />
                            <div>
                                <p>委员成员信息</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="organizedRight">
                    <div
                        class="organizedDes"
                        v-show="rightCardMessage == 'base'"
                    >
                        <img :src="photo" alt="" />
                        <p v-html="introduce"></p>
                    </div>
                    <div
                        class="organizedList"
                        v-show="rightCardMessage == 'member'"
                    >
                        <div
                            class="organizedtem"
                            v-for="(item, index) in leaders"
                            :key="index"
                        >
                            <img :src="item.photo" class="leaderImg" />
                            <p>{{ item.memberName }}</p>
                            <p>
                                <span v-if="item.post == 1">委员会书记</span
                                ><span v-if="item.post == 2">委员会副书记</span
                                ><span v-if="item.post == 3">委员会委员</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="buttonBox">
                <el-tabs
                    v-model="socialNum"
                    type="card"
                    @tab-click="handleClick"
                >
                    <el-tab-pane label="养老服务点" name="first">
                        <pension-services
                            :personData="socialOrgId"
                            v-if="socialOrgId != '' && socialNum == 'first'"
                        ></pension-services>
                    </el-tab-pane>
                    <el-tab-pane label="活动安排" name="second">
                        <activity-arrangement
                            :personData="socialOrgId"
                            v-if="socialOrgId != '' && socialNum == 'second'"
                        ></activity-arrangement>
                    </el-tab-pane>
                    <el-tab-pane label="健康管理" name="third">
                        <health-elderly
                            :personData="socialOrgId"
                            v-if="socialOrgId != '' && socialNum == 'third'"
                        ></health-elderly>
                    </el-tab-pane>
                    <el-tab-pane label="订餐管理" name="fourth">
                        <food-management
                            :personData="socialOrgId"
                            v-if="socialOrgId != '' && socialNum == 'fourth'"
                        ></food-management>
                    </el-tab-pane>
                    <el-tab-pane label="订单管理" name="five">
                        <order-management
                            :personData="socialOrgId"
                            v-if="socialOrgId != '' && socialNum == 'five'"
                        ></order-management>
                    </el-tab-pane>
                    <el-tab-pane label="社区活动" name="six">
                        <community-actives
                            :personData="socialOrgId"
                            v-if="socialOrgId != '' && socialNum == 'six'"
                        ></community-actives>
                    </el-tab-pane>
                    <el-tab-pane label="回访管理" name="seven">
                        <return-visit
                            :personData="socialOrgId"
                            v-if="socialOrgId != '' && socialNum == 'seven'"
                        ></return-visit>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>
<script>
import pensionServices from "./pensionServices"
import activityArrangement from "./activityArrangement"
import healthElderly from "./healthElderly"
import foodManagement from "./foodManagement"
import orderManagement from "./orderManagement"
import communityActives from "./communityActives"
import returnVisit from "./returnVisit"

export default {
    name: "socialOrgManage",
    inject: ["reload"], //注入
    data() {
        return {
            introduce: "",
            photo: "",
            socialOrgId: "", //组织关系select
            orgList: [], //组织关系列表
            rightCardMessage: "base", //组织头部状态切换
            partyInfo: "", //组织简介
            leaders: [], //组织成员
            socialNum: "first", //模块显示
        }
    },
    components: {
        pensionServices,
        activityArrangement,
        healthElderly,
        foodManagement,
        orderManagement,
        communityActives,
        returnVisit,
    },
    watch: {
        $route: {
            handler(val, oldval) {
                console.log(val) //新路由信息
                console.log(oldval) //老路由信息
            },
            // 深度观察监听
            deep: true,
        },
    },
    created() {
        this.getSelectData()
    },
    methods: {
        // 切换成员
        cardMessage(data) {
            this.rightCardMessage = data
        },

        // 获取组织数据
        getSelectData() {
            let params = {
                pageNo: 0,
                pageSize: -1,
            }
            this.$http
                .request({
                    url: "/ypt/admin/community/info/CommunityTree",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.orgList = []
                            this.socialOrgId = ""
                            this.introduce = ""
                            this.photo = ""
                            return
                        }
                        this.orgList = res.content
                        this.$nextTick(() => {
                            this.socialOrgId = res.content[0].id
                            this.introduce = res.content[0].introduce
                            this.photo = res.content[0].photo
                            this.leaders = res.content[0].leaders
                                ? res.content[0].leaders
                                : []
                        })
                    }
                })
        },

        // 组织关系select事件
        onSelectOrgIdChange(data) {
            this.socialOrgId = data
            this.leaders = []
            this.orgList.forEach((item) => {
                if (data == item.id) {
                    this.introduce = item.introduce
                    this.photo = item.photo
                    this.leaders = item.leaders ? item.leaders : []
                }
            })
        },
        // 组织菜单展示
        handleClick(tab, event) {
            console.log(tab, event)
            this.socialNum = tab.name
        },
    },
    destroyed() {},
}
</script>
<style lang="less" scoped>
/deep/.search_content {
    padding: 20px !important;
}
.elder_manage_title {
    position: relative;
    width: 100%;
    margin-bottom: 15px;
    &::after {
        position: absolute;
        left: 120px;
        right: 0;
        display: block;
        content: "";
        border-bottom: 1px solid #e4e7ed;
    }
    .title {
        box-sizing: border-box;
        display: inline-block;
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #409eff;
        font-size: 14px;
        border: 1px solid #e4e7ed;
        border-bottom: none;
        border-radius: 4px 4px 0 0;
        box-sizing: border-box;
        background: #ffffff;
    }
}
.newIndexContainer {
    display: flex;
    justify-content: flex-start;
    height: 280px;
    overflow: hidden;
    .organizedLeft {
        width: 270px;
        margin-right: 10px;
        .organizeSelct {
            width: 270px;
            margin-bottom: 15px;
            text-align: center;
        }
        .yzListDivLeft {
            height: 70px;
            display: flex;
            flex-direction: row;
            align-items: center;
            padding-left: 25px;
            margin-bottom: 10px;
            border-radius: 6px;
            cursor: pointer;
            img {
                width: 41px;
                margin-right: 25px;
            }
        }
        .yzListDivLeftBlue {
            background: #bcdef8;
            p {
                font-size: 18px;
                color: #0b54c1;
                font-weight: bold;
            }
        }
        .yzListDivLeftViolet {
            background: #e3daeb;
            p {
                font-size: 18px;
                color: #90489f;
                font-weight: bold;
            }
        }
    }
    .organizedRight {
        flex: 1;
        width: 0;
        .organizedDes {
            display: flex;
            img {
                max-width: 20%;
                height: 210px;
                margin-right: 10px;
            }
            p {
                flex: 1;
                font-size: 0.9vw;
                color: #666;
                line-height: 28px;
                text-indent: 36px;
                overflow: hidden;
            }
        }
        .organizedList {
            display: flex;
            margin-left: 10px;
            overflow: hidden;
            .organizedtem {
                p {
                    text-align: center;
                    color: #333;
                    font-size: 14px;
                    padding-top: 10px;
                }
            }
        }
    }
}
.buttonBox {
    margin: 15px 0;
    .socialMr15 {
        margin-right: 15px;
    }
}
.leaderImg {
    width: 150px;
    height: 150px;
    margin-right: 12px;
    margin-bottom: 10px;
}
</style>